import {Fonction} from "./fonction.model";
import {Profil} from "./profil.model";
import { Role } from "./role.model";
import {Utilisateur} from "./utilisateur.model";

export class User {
    constructor(
        public id?: number,
        public nom?: string,
        public prenom?: string,
        public telephone?: string,
        public email?: string,
        public genre?: string,
        public deleted?: boolean,
        public activated?: boolean,
        public typeUtilisateur?: string,
        public createdDate?: string,
        public createdBy?: string,
        public fonction?: Fonction,
        public utilisateur?: Utilisateur,
        public role?: Role
    ) {
    }
}
